import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import tabTournoiInterne from "../../../__params/tab-pages/competitions/tab-tournointerne";
import SideMenu from "../../../components/menus/m-side";
import { useNavHeight } from "../../../__utils/context/navheightprovider";
import "../../../assets/css/tabletournoiinterne.css";

const StInterne = () => {
  const { navbarHeight, sideNavHeight, breadNavHeight } = useNavHeight();

  // récupération de l'année en cours
  const currentYear = new Date().getFullYear();

  // Tri par ordre décroissant sur les saisons
  const sortedTabTournoiInterne = tabTournoiInterne.map((categorie) => ({
    ...categorie,
    result: [...categorie.result].sort((a, b) => b.season - a.season),
  }));

  return (
    <main role="main" className="mc-fond-courts-couverts">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col
            md={3}
            className="gx-0"
            style={{
              position: "sticky",
              top: navbarHeight,
              background: "rgba(0, 43, 110, 0.5)",
              zIndex: "1000",
            }}
          >
            <SideMenu />
          </Col>
          <Col md={9} className="gx-0">
            {/***********************************************************************/}
            {/******************************************** PALMARES Tournoi interne */}
            {/***********************************************************************/}

            {sortedTabTournoiInterne.map((palmares) => (
              <Card
                key={palmares.id}
                bg="transparent"
                className="my-2 border-0"
              >
                <span
                  className="mc-marker"
                  style={{
                    top: -(navbarHeight + sideNavHeight + breadNavHeight),
                  }}
                  id="tournointerne"
                ></span>
                <Card.Body
                  style={{ backgroundColor: "rgba(246, 181, 96, 0.81)" }}
                  className="m-2 p-2 rounded"
                >
                  <Card.Header
                    className="mc-rampart mc-rfs-2 m-2 text-primary rounded"
                    style={{ backgroundColor: "rgba(246, 240, 214, 0.81)" }}
                  >
                    PALMARÈS - {palmares.category}
                  </Card.Header>
                </Card.Body>
                <Card.Body>
                  <Table responsive bordered className="mc-tableti">
                    <thead>
                      <tr>
                        <th>Saison</th>
                        <th>Vainqueur 🏆</th>
                        <th>Classement</th>
                        <th>Finaliste 💐</th>
                        <th>Classement</th>
                      </tr>
                    </thead>
                    {palmares.result.map((item) => (
                      <tbody key={item.season}>
                        {item.season === currentYear.toString() ? (
                          <tr
                            style={{
                              fontSize: "1.5em",
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              fontWeight: "700",
                            }}
                          >
                            <td className="text-danger">{item.season}</td>
                            <td className="text-success">{item.WinnerName}</td>
                            <td className="text-success">
                              {item.WinnerRanking}
                            </td>
                            <td>{item.LoserName}</td>
                            <td>{item.LoserRanking}</td>
                          </tr>
                        ) : (
                          <tr>
                            <td>{item.season}</td>
                            <td>{item.WinnerName}</td>
                            <td>{item.WinnerRanking}</td>
                            <td>{item.LoserName}</td>
                            <td>{item.LoserRanking}</td>
                          </tr>
                        )}
                      </tbody>
                    ))}
                  </Table>
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default StInterne;
